export default "__VITE_ASSET__CeAbj4b1__"